// 返仓设置工具函数 - 类似于 WeightParcelPage 中使用 bluetoothScaleStore 的方式
import { useReturnToWhsSettingsStore } from '../store/returnToWhsSettingsStore';

/**
 * 获取返仓设置状态 - 可以在任何地方调用
 */
export const getReturnToWhsSettings = () => {
    const state = useReturnToWhsSettingsStore.getState();
    return {
        directAcceptDeliveryPackages: state.directAcceptDeliveryPackages,
        directWarehouseEntry: state.directWarehouseEntry,
    };
};

/**
 * 重置所有返仓设置（用于退出登录时调用）
 */
export const resetAllReturnToWhsSettings = () => {
    const { resetAllSettings } = useReturnToWhsSettingsStore.getState();
    resetAllSettings();
    console.log('All return to WHS settings have been reset');
};

/**
 * 检查是否启用了直接接收件派送和派送中包裹
 * 可以在扫描逻辑中使用这个函数来判断是否需要特殊处理
 */
export const isDirectAcceptDeliveryPackagesEnabled = (): boolean => {
    const state = useReturnToWhsSettingsStore.getState();
    return state.directAcceptDeliveryPackages;
};

/**
 * 检查是否启用了未入库派送仓的直接入库
 * 可以在扫描逻辑中使用这个函数来判断是否需要特殊处理
 */
export const isDirectWarehouseEntryEnabled = (): boolean => {
    const state = useReturnToWhsSettingsStore.getState();
    return state.directWarehouseEntry;
};